var module = angular.module('octopusApp.library');

module.directive('feedEditor', function() {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: 'areas/library/feeds/views/editor.html'
  };
});





//////////////////
// WEBPACK FOOTER
// ./app/areas/library/feeds/directives/feed_editor.js
// module id = 6710029808876492
// module chunks = 1